import { render, staticRenderFns } from "./SupplierSells.vue?vue&type=template&id=0af6a727&"
import script from "./SupplierSells.vue?vue&type=script&lang=js&"
export * from "./SupplierSells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports